var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYeswareIntegrationsGmail = function SvgYeswareIntegrationsGmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 71 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69.776,
    height: 71.057,
    rx: 20.881,
    fill: "#fff",
    stroke: "#ECF0F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.593 54.503h7.293V36.792l-10.418-7.814v22.4a3.125 3.125 0 0 0 3.125 3.125Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.89 54.503h7.294a3.125 3.125 0 0 0 3.125-3.126v-22.4l-10.418 7.815",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.89 23.248v13.544l10.42-7.814V24.81c0-3.865-4.413-6.068-7.502-3.75",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.887 36.792V23.248l12.502 9.376 12.502-9.376v13.544l-12.502 9.376",
    fill: "#EA4335"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.468 24.81v4.168l10.418 7.814V23.248L19.97 21.06c-3.094-2.318-7.501-.115-7.501 3.75Z",
    fill: "#C5221F"
  })));
};
export default SvgYeswareIntegrationsGmail;